import { createGenericFormSlice, SliceState } from "./genericFormSlice";
import { Perm } from "../types";

export interface EditHostState {
  perm: Perm;
  emailOptOut: boolean;
}
const formSlice = createGenericFormSlice({
  name: "editHost",
  initialState: {} as SliceState<EditHostState>,
  reducers: {},
});

export const { reset, initialize, updateField } = formSlice.actions;
const editHostReducer = formSlice.reducer;
export default editHostReducer;
